<script>
import WhitelabelFileTypes from "@/enums/WhitelabelFileTypes";

export default {
  data() {
    return {
      maxUploadSize: 512 * 512,
      allowedFileTypes: ['image/png', 'image/x-icon'],
      faviconFile: null,
      previewUrl: '',
      defaultUrl: '/assets/logos/fp/favicon.ico',
    };
  },
  computed: {
    WhitelabelFileTypes() {
      return WhitelabelFileTypes
    },
    favicon() {
      return this.$store.state?.whitelabel?.favicon?.custom;
    },
  },
  watch: {
    favicon(newVal) {
      if (!this.faviconFile && newVal) {
        this.previewUrl = newVal;
        this.setFavicon(newVal);
      }
    }
  },
  created() {
    this.$store.dispatch('getFavicon').then(() => {
      if (this.favicon) {
        this.setFavicon(this.favicon);
      }
    });
  },
  methods: {
    setFavicon(blobUrl) {
      let link = document.querySelector("link[rel~='icon']");

      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
      }

      link.href = blobUrl;
    },
    onHandleFaviconUpload(file,type) {

      if (file) {
        if (!this.allowedFileTypes.includes(file.type)) {
          return;
        }

        if (file.size > this.maxUploadSize) {
          this.$notify(this.$t('component.whitelabel.custom.favicon.upload.file.too.large'), {type: 'error'});
          return;
        }

        const img = new Image();
        const objectUrl = URL.createObjectURL(file);

        img.onload = () => {
          if (img.width > 48 || img.height > 48) {
            this.$notify(this.$t('component.whitelabel.custom.favicon.upload.file.wrong.size'), {type: 'error'});
            URL.revokeObjectURL(objectUrl);
            return;
          }

          this.faviconFile = file;
          this.previewUrl = objectUrl;
          this.setFavicon(objectUrl);
          this.$store.dispatch('putFavicon', {type, file});
        };

        img.onerror = () => {
          this.$notify(this.$t('component.whitelabel.custom.favicon.upload.file.invalid.image'), {type: 'error'});
          URL.revokeObjectURL(objectUrl);
        };

        img.src = objectUrl;
      }
    },
    resetFavicon() {
      this.faviconFile = null;
      this.previewUrl = this.defaultUrl;
      this.setFavicon(this.defaultUrl);
      this.$store.dispatch('resetFavicon');
    },
  }
};
</script>

<template>
  <v-container fluid class="pt-0">
    <!--    HEADER-->
    <v-row class="pt-0">
      <v-col class="pt-0">
        <h3 class="float-left">{{ $t('component.whitelabel.custom.favicon.heading') }}</h3>
        <v-tooltip top>
          <template #activator="{ on }">
            <v-btn id="reset-default-favicon" class="float-right" icon color="primary" v-on="on" @click="resetFavicon">
              <v-icon>mdi-autorenew</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('component.whitelabel.custom.favicon.reset.button.tooltip') }}</span>
        </v-tooltip>
      </v-col>
    </v-row>

    <v-divider class="mb-4"/>

    <!--    FILE BOX-->
    <v-row id="custom-favicon-container" class="mt-4">
      <v-col>
        <v-card
          outlined
          elevation="2"
          class="pa-4"
          style="cursor: pointer;"
          :disabled="!$store.getters.urls.subdomain"
          @click="$refs.faviconFileInput.click()">
          <v-card-text class="text-center">
            <img
              :src="!!favicon ? favicon : previewUrl || defaultUrl"
              alt="Logo Dunkel Vorschau"
              height="48"
              class="my-4"/>
            <input
              id="custom-favicon-file-input"
              ref="faviconFileInput"
              type="file"
              accept=".ico,.png"
              style="display: none;"
              @change="(event)=>onHandleFaviconUpload(event.target.files[0], WhitelabelFileTypes.Favicon)"/>
            <div v-if="faviconFile" class="mt-2">
              <div>{{ faviconFile.name }}</div>
              <div class="text-caption">
                {{ (faviconFile.size / 1024).toFixed(2) }} KB
              </div>
            </div>
            <div v-else class="text-caption mt-2">
              {{ $t('component.whitelabel.custom.favicon.upload.hint') }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
.v-avatar {
  background-color: #f5f5f5;
}
</style>
